import React from "react";
import HomepageSecondaryLayout from "../../../components/homepages/homepageSecondaryLayout.tsx";
import colors from "../../../constants/colors.ts";
import Section2 from "./section2.clients.tsx";

const Section1: React.FC = () => {
  return (
    <HomepageSecondaryLayout
      backgroundColor={colors.BLUE_DDEFFF}
      title={"TITLE.MotivelePentruCareClientiiNeAleg"}
      button={"BUTTON.CereOferta"}
      buttonColour={colors.WHITE}
      buttonBackgroundColour={colors.BLUE_242737}
      media={'Secondary-Homepage-Image-Layout'}
    >
      <Section2 />
    </HomepageSecondaryLayout>
  );
};

export default Section1;
